<template>
  <div class="macs">
    <el-form :inline="true" class="demo-form-inline">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-input v-model="search" placeholder="Поиск" class="search" :disabled="tableData == null || tableData.length == 0 || loading" prefix-icon="el-icon-search"></el-input>
        </el-col>
        <el-col :span="12">
          <el-date-picker
            v-model="dateRange"
            :disabled="loading"
            type="daterange"
            align="center"
            unlink-panels
            range-separator="-"
            start-placeholder="Start date"
            end-placeholder="End date"
            value-format="timestamp"
            format="dd.MM.yyyy"
            v-on:change="fetchData"
            :picker-options="pickerOptions"
            :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </el-col>
        <el-col :span="4" style="text-align: right">
          <el-button :plain="true"  @click="fetchData" :disabled="loading" icon="el-icon-refresh">Обновить</el-button>
        </el-col>
      </el-row>
    </el-form>
    <el-table sum-text="Сумма" max-height="100%" cell-class-name="cell-style" :data="filtered" style="width: 100%" empty-text="Нет данных" v-loading="loading" :default-sort = "{prop: 'confirmed_at', order: 'descending'}">
      <el-table-column prop="id" label="ID" width="70" sortable></el-table-column>
      <el-table-column prop="plan" label="Пакет" sortable></el-table-column>
      <el-table-column prop="price_value" :sort-method="sortByPrice" label="Цена" sortable>
        <template slot-scope="scope">
          <div>
            <span>{{scope.row.price_value}} {{scope.row.price_currency}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="period" label="Срок"></el-table-column>
      <el-table-column prop="confirmed_at" :sort-method="sortByDate" label="Дата" sortable>
        <template slot-scope="scope">
          <div>
            <span v-if="scope.row.confirmed_at">{{dateFormatter(scope.row.confirmed_at)}}</span><span v-else>-</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="ip" label="IP"></el-table-column>

      <!-- <el-table-column prop="comments" label="Comments"></el-table-column> -->
    </el-table>
    <el-row :gutter="20" class="last">
        <el-col :span="24">
          <el-tag>Всего заказов: {{this.totalCount}}</el-tag>
          <ul class="subtotal">
            <li v-for="row in subTotal">
              <el-tag type="success">{{ row.key }}: {{ row.value }}</el-tag>
            </li>
          </ul>
        </el-col>
      </el-row>
  </div>
</template>

<script>

  import * as Api from '../api.js'
  import moment from 'moment-timezone'

  export default {
    data () {
      return {
        tableData: null,
        loading: true,
        search: null,
        lastFetchId: null,
        updateTimer: null,
        dateRange: [],
        pickerOptions: {
          shortcuts: [{
            text: '7 дней',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '30 дней',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }],
          firstDayOfWeek: 1
        },
      }
    },
    created () {
      this.fetchData()
      this.updateTimer = setInterval(() => {
        this.fetchData(true)
      }, 1000 * 60 * 10)
    },
    destroyed () {
      clearInterval(this.updateTimer)
    },
    // watch: {
    //   '$route': 'fetchData'
    // },
    computed: {
      filtered () {
        if (!this.search) {
          return this.tableData
        } else {
          return this.tableData.filter(function(row) {
            if (row.plan && row.plan.toLowerCase().includes(this.search.toLowerCase())) {
              return true
            }
            if (row.ip && row.ip.toLowerCase().includes(this.search.toLowerCase())) {
              return true
            }
          }.bind(this))
        }
      },
      totalCount () {
        if (this.filtered != null) {
          return this.filtered.length
        }
        return 0
      },
      subTotal () {

        if (this.filtered != null && this.filtered.length > 0) {
          var st = {}
          for (let order of this.filtered) {
            if (!(order.price_currency_code in st)) {
              st[order.price_currency_code] = {
                value: 0,
                key: order.price_currency_code
              }
            }
            st[order.price_currency_code].value += parseFloat(order.price_value)
          }

          for(var currency in st) {
            st[currency].value = Math.round(st[currency].value * 100) / 100
          }

          console.log(st)
          return st
        } else {
          return {}
        }
      },
    },
    methods: {

      fetchData (dontBlock, lastFetchIdTmp) {
        this.loading = dontBlock != true ? true : false
        var s = null
        var e = null
        if (this.dateRange && this.dateRange.length == 2) {
          s = this.dateRange[0] / 1000
          e = this.dateRange[1] / 1000
        }
        Api.orders(s, e).then(r => {
          if (!lastFetchIdTmp || lastFetchIdTmp == this.lastFetchId) {
            this.loading = false
            this.tableData = r.data
          }
        }, e => {
          this.loading = false
          if (!dontBlock) {
            this.showError(e)
          }
        })
      },

      showError (e) {
        this.$alert('API Error, please contact support', 'Error', {
          confirmButtonText: 'OK',
          type: 'error'
        })
      },

      dateFormatter (date) {
        if (date) {
          return moment(date).local().format('DD.MM.YYYY HH:mm:ss')
        }
        return date
      },

      sortByDate (a, b) {
        if (!a.confirmed_at && b.confirmed_at) return -1
        if (!b.confirmed_at && a.confirmed_at) return 1
        if (!b.confirmed_at && !a.confirmed_at) return 0
        return (a.confirmed_at < b.confirmed_at) ? -1 : ((a.confirmed_at > b.confirmed_at) ? 1 : 0)
      },

      sortByPrice (a, b) {
        const ap = parseFloat(a.price_value)
        const bp = parseFloat(b.price_value)
        return (ap < bp) ? -1 : ((ap > bp) ? 1 : 0)
      },

    }
  }

</script>

<style lang="scss">
  .macs {
    max-height: 100%;
    display: flex;
    flex-direction: column;
    form {
      flex-basis: auto;
      flex-shrink: 0;
      .el-input__inner {
        line-height: inherit;
      }
    }
    table {
      flex-basis: 100%;
      flex-grow: 1;
      flex-shrink: 1;
    }

    .el-table {
      display: flex;
      flex-direction: column;
      margin-bottom: 15px;
    }

    .el-table__header-wrapper {
      flex-basis: auto;
      flex-shrink: 0;
    }

    .el-row {
      margin-bottom: 15px;
      &.last {
        margin-bottom: 0;
      }
    }
    .el-form-item.refresh-button {
      margin-right: 0
    }
    .el-tag, .el-switch {
      transition: none !important
    }
    .circle {
      display: inline-block;
      width: 8px;
      height: 8px;
      -moz-border-radius: 4px;
      -webkit-border-radius: 4px;
      border-radius: 4px;
      margin-left: 5px;
    }
    .el-tag {
      height: 40px;
      line-height: 38px;
      font-size: 14px;
    }
    .subtotal {
      list-style-type: none;
      list-style: none;
      display: inline-block;
      padding: 0;
      margin: 0;
      li {
        display: inline-block;
        margin-right: 5px;
      }
    }
  }
</style>